import { apiRequest } from '@peruselab/api-client/httpRequest';
import type { Variant } from './Variant';

export async function getVariant(id: string): Promise<Variant> {
  return apiRequest<Variant>(`/variants/${encodeURIComponent(id)}`, 'variant');
}
